import { Group } from 'lib/_types'
import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for Group context
const GROUP_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'group',
  format: 'jsonschema',
  version: '1-0-0',
}

export type GroupContextSchemaData = {
  position?: number // An index position of group on the screen. Ads post is excluded from this context.
  group_id: number // A content group ID
  group_category: string // Category of this group
  owner_id: number // A user ID of the group owner
  is_owner?: boolean // A Boolean indicating if the viewer is an owner of this group
  is_moderator?: boolean // A Boolean indicating if the viewer is a moderator of this group
  is_member?: boolean // A Boolean indicating if the viewer is a member of this group
  is_request_pending?: boolean // A Boolean indicating if the viewer has join request pending.
  is_require_age_verify: boolean // A Boolean indicating if this group requires members to verify their age
  members?: number // A number of current member in this group
  posts?: number // A number of current posts in this group
}

export const groupContextSchema = (
  data: GroupContextSchemaData
): ContextSchema<GroupContextSchemaData> => ({
  schema: schemaPath(GROUP_SCHEMA),
  data,
})

export const groupToGroupContextSchema = ({
  group,
  currentUserId,
}: {
  group?: Partial<Group>
  currentUserId?: number
}): GroupContextSchemaData => {
  if (!group) return

  return {
    group_id: group.id,
    group_category: group.group_category_id?.toString(),
    owner_id: group.owner?.id,
    is_owner: group.owner?.id == currentUserId,
    // is_moderator: false,
    is_member: group.is_joined,
    is_request_pending: group.is_pending,
    is_require_age_verify: group.only_verified_age,
    members: group.groups_users_count,
    posts: group.posts_count,
  }
}
